import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardOverview from "../Pages/DashboardOverview";

// Analytics
import AnalyticsDashboard from "../Pages/Analytics/Dashboard";
import UserAnalytics from "../Pages/Analytics/UserAnalytics";
import TradingAnalytics from "../Pages/Analytics/TradingAnalytics";
import EventsAndMarketsAnalytics from "../Pages/Analytics/EventsAndMarketsAnalytics";
import CategoryAnalytics from "../Pages/Analytics/CategoryAnalytics";

// Users data
import Users from "../Pages/Users";

// User detail
import UserDetail from "../Pages/UserDetail";

//events
import Events from "../Pages/Events";
import EventDetail from "../Pages/Events/EventDetail";
import CalendarView from "../Pages/CalendarView";

// Live Sports
import LiveSports from "../Pages/LiveSports";

// Orders
import Orders from "../Pages/Orders";

// admins
import Admins from "../Pages/Admins";

//closing events
import ClosingEvents from "../Pages/ClosingEvent";

//Active resolution
import ActiveResolution from "../Pages/ActiveResolution";
import ResolutionDetail from "../Pages/ActiveResolution/ResolutionDetail";

//trending events
import TrendingEvents from "../Pages/TrendingEvents";

import Categories from "../Pages/Categories";
import NewCategory from "../Pages/Categories/NewCategory";
import EditCategory from "../Pages/Categories/EditCategory";

//Sub categories
import SubCategories from "../Pages/SubCategories";
import EditSubCategory from "../Pages/SubCategories/EditSubCategory";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import Regions from "../Pages/Regions";

// Withdrawals
import Withdrawals from "../Pages/Withdrawals";
import Leagues from "../Pages/Leagues";
import EditLeague from "../Pages/Leagues/EditLeague";
import WalletBalance from "../Pages/WalletBalance";
import WalletAddress from "../Pages/WalletAddress";
import UserWalletBalance from "../Pages/UserWalletBalance";
import CurrencyList from "../Pages/CurrencyList/Index";
import AddCurrencyList from "../Pages/CurrencyList/AddCurrencyList";
import EditCurrencyList from "../Pages/CurrencyList/EditCurrencyList";
import TransactionList from "../Pages/TransactionList";
import SingleTransactionList from "../Pages/TransactionList/[id]";

// Market Maker
import MarketMaker from "../Pages/MarketMaker";
import WithdrawDetails from "../Pages/WithdrawalDetails/Index";
import Deposits from "../Pages/DepositTransaction";
import Withdraws from "../Pages/WithdrawTransaction";
import AdminAccount from "../Pages/AdminAccount";
import MatchDetails from "../Pages/Matches";
import Settlement from "../Pages/Settlement";
import UserTrades from "../Pages/UserTrades";
import GameHistory from "../Pages/GameHistory";
import AllPacks from "../Pages/Packs/AllPacks";
import AllItems from "../Pages/Packs/AllItems";
import TotalBattle from "../Pages/Battle/TotalBattle";
import InLive from "../Pages/Battle/InLive";
import ViewAdmin from "../Pages/Admins/ViewAdmin";
import EditAdmin from "../Pages/Admins/EditAdmin";
import UpdateAdminPassword from "../Pages/Admins/UpdateAdminPassword";
import AddPack from "../Pages/Packs/AddPack";
import ViewPack from "../Pages/Packs/ViewPack";
import UpdatePack from "../Pages/Packs/UpdatePack";
import Items from "../Pages/Items/Items";
import ViewItem from "../Pages/Items/ViewItem";
import AddItem from "../Pages/Items/AddItem";
import EditItem from "../Pages/Items/EditItem";
import UpdateUser from "../Pages/Users/UpdateUser";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard-overview", component: <DashboardOverview /> },
  //trending-events
  { path: "/dashboard-events", component: <TrendingEvents /> },

  // Analytics
  { path: "/analytics/dashboard", component: <AnalyticsDashboard /> },
  { path: "/analytics/users", component: <UserAnalytics /> },
  { path: "/analytics/trading", component: <TradingAnalytics /> },
  { path: "/analytics/markets", component: <EventsAndMarketsAnalytics /> },
  { path: "/analytics/categories", component: <CategoryAnalytics /> },

  // users data
  { path: "/users", component: <Users /> },
  // user detail
  { path: "/users/:id", component: <UserDetail /> },
  { path: "/users/update/:id", component: <UpdateUser /> },

  //packs
  { path: "/all-packs", component: <AllPacks /> },
  { path: "/add-pack", component: <AddPack /> },
  { path: "/packs/view/:id", component: <ViewPack /> },
  { path: "/packs/edit/:id", component: <UpdatePack /> },

  //items
  { path: "/items", component: <Items /> },
  { path: "/items/view/:id", component: <ViewItem /> },
  { path: "/items/create", component: <AddItem /> },
  { path: "/items/edit/:id", component: <EditItem /> },

  //battle
  { path: "/total-battle", component: <TotalBattle /> },
  { path: "/in-live", component: <InLive /> },

  //transaction
  { path: "/adminaccountdetails", component: <AdminAccount /> },
  { path: "/deposithistory", component: <Deposits /> },
  { path: "/withdrawhistory", component: <Withdraws /> },
  //Gamehistory
  { path: "/gamehistory", component: <GameHistory /> },

  //mathces
  { path: "/mathces", component: <MatchDetails /> },
  { path: "/usertradehistory", component: <UserTrades /> },

  { path: "/settlemethistory", component: <Settlement /> },

  // Withdrawals
  { path: "/withdrawals", component: <Withdrawals /> },
  { path: "/withdraws/:id", component: <WithdrawDetails /> },

  { path: "/wallet-balance", component: <WalletBalance /> },

  { path: "/wallet-address", component: <WalletAddress /> },
  { path: "/user-wallet-balance", component: <UserWalletBalance /> },

  { path: "/currency-list", component: <CurrencyList /> },
  { path: "/add-currency-list", component: <AddCurrencyList /> },
  { path: "/currency-list/:id", component: <EditCurrencyList /> },

  { path: "/transaction-list", component: <TransactionList /> },
  { path: "/transaction-list/:id", component: <SingleTransactionList /> },

  //Events
  { path: "/events", component: <Events /> },
  { path: "/events/edit/:id", component: <EventDetail /> },
  { path: "/events-calendar", component: <CalendarView /> },

  // Live Sports
  { path: "/live-sports", component: <LiveSports /> },

  //Orders
  { path: "/orders", component: <Orders /> },

  // Admins
  { path: "/admins", component: <Admins /> },
  { path: "/admins/view/:id", component: <ViewAdmin /> },
  { path: "/admins/edit/:id", component: <EditAdmin /> },
  { path: "/admins/password/:id", component: <UpdateAdminPassword /> },

  // Closing Events
  { path: "/closing-events", component: <ClosingEvents /> },

  // Active Resolution
  { path: "/active-resolution", component: <ActiveResolution /> },
  { path: "/active-resolution/:id", component: <ResolutionDetail /> },

  //Categories
  { path: "/categories", component: <Categories /> },
  { path: "/categories/new", component: <NewCategory /> },
  { path: "/categories/edit/:id", component: <EditCategory /> },

  //Sub Categories
  { path: "/sub-categories", component: <SubCategories /> },
  { path: "/sub-categories/edit/:id", component: <EditSubCategory /> },

  // Leagues
  { path: "/leagues", component: <Leagues /> },
  { path: "/leagues/edit/:id", component: <EditLeague /> },

  // Market Maker
  { path: "/market-makers", component: <MarketMaker /> },

  { path: "/regions", component: <Regions /> },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/analytics/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
